import * as React from "react";
import { forwardRef } from "react";
const SvgCustomTextFieldBlank = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M2.5 4.49658H13.5M2.5 8H13.5M2.5 11.5034H7.21429", stroke: "currentColor", strokeWidth: 1.33333, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgCustomTextFieldBlank);
export { ForwardRef as ReactComponent };
